export default {
  'digitalSignatureFieldMapping.title': 'Mapeo Campos Firma Digital',

  'digitalSignatureFieldMapping.form.form': 'Formulario',
  'digitalSignatureFieldMapping.form.field': 'Campo',
  'digitalSignatureFieldMapping.form.isShowDigitalSignatureStampEnabled':
    '¿Mostrar Sello Firma Digital?',
  'digitalSignatureFieldMapping.form.signaturePosition': 'Posición Sello Firma Digital',
  'digitalSignatureFieldMapping.form.pageToPlaceDigitalStamp':
    'Página Para Colocar Sello Firma Digital',

  'digitalSignatureFieldMapping.form.select.TopStart': 'Parte Superior - Inicio',
  'digitalSignatureFieldMapping.form.select.TopMiddle': 'Parte Superior - Centro',
  'digitalSignatureFieldMapping.form.select.TopEnd': 'Parte Superior - Fin',

  'digitalSignatureFieldMapping.form.select.CenterStart': 'Parte Central - Inicio',
  'digitalSignatureFieldMapping.form.select.CenterMiddle': 'Parte Central - Centro',
  'digitalSignatureFieldMapping.form.select.CenterEnd': 'Parte Central - Fin',

  'digitalSignatureFieldMapping.form.select.BottomStart': 'Parte Inferior - Inicio',
  'digitalSignatureFieldMapping.form.select.BottomMiddle': 'Parte Inferior - Centro',
  'digitalSignatureFieldMapping.form.select.BottomEnd': 'Parte Inferior - Fin',
};
